/* eslint-disable angular/file-name */
angular.module('zc.core')
  .component('zcIncreaseOrDecreasePercentage', {
    templateUrl: '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html',
    bindings: {
      from: '<',
      to: '<',
    },
    controller: IncreaseOrDecreasePercentageController,
  });

IncreaseOrDecreasePercentageController.$inject = ['$filter'];
function IncreaseOrDecreasePercentageController($filter) {
  const vm = this;

  vm.$onInit = () => {
    vm.percentage = null;
    vm.showValue = null;
    showValue();
  };

  function showValue() {
    if(!vm.from) {
      vm.percentage = null;
      vm.showValue = null;
      return;
    }
    vm.percentage = (vm.to / vm.from - 1) * 100;
    if(vm.percentage === 0) {
      vm.showValue = '±0';
    } else if(vm.percentage > 0) {
      vm.showValue = `+${$filter('number')(vm.percentage, 0)}%`;
    } else {
      vm.showValue = `-${$filter('number')(-vm.percentage, 0)}%`;
    }
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.js